import { useQuery } from "react-query";
import { getAllSnowflakesDetails } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetAllSnowflakes = () => {
  return useQuery(["getSnowFlakes"], () => getAllSnowflakesDetails(), {
    refetchOnWindowFocus: false,
  });
};
export default useGetAllSnowflakes;
